import { useTranslation } from 'react-i18next';
import En from '../../Icons/LangFlags/En';
import Ua from '../../Icons/LangFlags/Ua';
import Ru from '../../Icons/LangFlags/Ru';
import styles from './LangSelector.module.css';
// import i18n from '../../../assets/i18n';

const lngs = {
  en: { nativeName: 'English', icon: <En /> },
  ua: { nativeName: 'Ukrainian', icon: <Ua /> },
  es: {
    nativeName: 'Spanish',
    icon: <img src='/img/es-flag.svg' alt='spanish' />,
  },
  ru: { nativeName: 'Russian', icon: <Ru /> },
};

const LangSelector = ({ menuSmall = '', menuMiddle = '', menuBig = '' }) => {
  const { t, i18n } = useTranslation();
  // const [selectedLang, setSelectedLang] = useState('English');

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);

  // const lng = navigator.language;

  // const handleLangSelect = (lang) => {
  //   setSelectedLang(lang);
  //   i18n.changeLanguage(lang);
  // };
  return (
    <div className={styles.langSelector}>
      <button className={styles.langSelectorButton}>
        <span>{t('lang.select')}</span>
      </button>

      <div className={styles.langOptions}>
        <div>
          {Object.keys(lngs).map((lng) => (
            <div
              className={styles.langOption}
              key={lng}
              style={{
                fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal',
              }}
              // type="submit"
              onClick={() => i18n.changeLanguage(lng)}
            >
              {lngs[lng].icon}
              {lngs[lng].nativeName}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LangSelector;
